// extracted by mini-css-extract-plugin
export default {"whiteSpace":"field-readonly-comment_whiteSpace__5fgR3","label":"field-readonly-comment_label__weaPB"};